import React, { useState } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import './Navigation.css';

const Navigation = (props) => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);

  return (
    <div className="container">
      <Navbar fixed='top' className="nv c1" color="faded" light>
        <NavbarBrand href="/" className="mr-auto">
          <div className="column">
            <div className="title">Christian Wenger</div>
            <div className="subtitle">Zuverlässig, kompetent, lösungsorientiert</div>
          </div>
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse isOpen={!collapsed} navbar>
          <Nav navbar>
            <NavItem>
              <NavLink href="#about">Über Mich</NavLink>
              <NavLink href="#product">Angebot</NavLink>
              <NavLink href="#contact">Kontakt</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default Navigation;